// material-ui
import { CameraOutlined, UploadOutlined } from '@ant-design/icons';
import { Typography, Stack } from '@mui/material';

// assets
import { DropzoneType } from 'types/dropzone';

// ==============================|| UPLOAD - PLACEHOLDER ||============================== //

export default function PlaceholderContent({ type }: { type?: string }) {
    return (
        <>
            {type !== DropzoneType.standard && (
                <Stack
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                    direction="column"
                    sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
                >
                    <UploadOutlined style={{ fontSize: 50, color: '#1890FF' }} />
                    <Stack spacing={1} alignItems="center">
                        <Typography variant="h5">Drag & Drop or Select file</Typography>

                        <Typography color="secondary">
                            Drop files here or click&nbsp;
                            <Typography component="span" color="primary" sx={{ textDecoration: 'underline' }}>
                                browse
                            </Typography>
                            &nbsp;thorough your machine
                        </Typography>
                    </Stack>
                </Stack>
            )}
            {type === DropzoneType.standard && (
                <Stack alignItems="center" justifyContent="center" sx={{ height: 1 }}>
                    <CameraOutlined style={{ fontSize: '32px' }} />
                </Stack>
            )}
        </>
    );
}
